/**
 * MIRA Tooltip Component
 * Wraps Shadcn Tooltip with MIRA design system styles
 */

import React from 'react';
import {
  Tooltip as ShadcnTooltip,
  TooltipContent as ShadcnTooltipContent,
  TooltipProvider as ShadcnTooltipProvider,
  TooltipTrigger as ShadcnTooltipTrigger,
} from '@/components/ui/tooltip';
import { cn } from '@/lib/utils';
import styles from '@/styles/components/tooltip.module.css';

export const TooltipProvider = ShadcnTooltipProvider;
export const Tooltip = ShadcnTooltip;
export const TooltipTrigger = ShadcnTooltipTrigger;

export const TooltipContent = React.forwardRef(
  ({ className, ...props }, ref) => {
    return (
      <ShadcnTooltipContent
        ref={ref}
        className={cn(styles.miraTooltipContent, className)}
        {...props}
      />
    );
  }
);

TooltipContent.displayName = 'MiraTooltipContent';
